// extracted by mini-css-extract-plugin
export default {"wrapper":"panel-module--wrapper--12ed8","icon":"panel-module--icon--409c0"};